import React from 'react'

const GitHome = () => {
  return (
    <div>
        <h1>Git Home</h1>
    </div>
  )
}

export default GitHome